export class Poliza {
  fecha_busqueda: any = null;
  listado_poliza: Array<any> = [];
  poliza_seleccionada: any;
  error: boolean = false;
  buscandoPoliza: boolean = false;
  msgError: string;
}
